<template>
    <v-sheet class="d-flex flex-column">
        <AmortizationBackToolbar :page="1" />
        <section class="px-4">
            <v-select
                v-model="selected_creditor"
                :items="creditors"
                :label="translate('common.debts_from')"
                :menu-props="{
                    contentClass: 'custom-menu-content'
                }"
                class="mb-6"
                item-title="name"
                item-value="id"
                variant="outlined"
                hide-details
            />
            <div
                v-if="selected_creditor"
                class="text-subtitle-1 bold mb-4"
            >
                {{ translate('common.include_which_debts') }}
                {{ `(${selected_debts.length}/${debts.length})` }}
            </div>
        </section>
        <section class="flex-grow-1 overflow-y-auto px-4">
            <v-checkbox
                v-for="(debt, index) in debts"
                :key="index"
                v-model="selected_debts"
                :label="label(debt)"
                :value="debt['_id']"
                hide-details
            />
        </section>
        <v-btn
            :disabled="!selected_debts.length"
            :loading="loading"
            @click="next"
            class="ma-4"
            variant="outlined"
        >
            {{ translate('common.move_on') }}
        </v-btn>
    </v-sheet>
</template>

<script>
import AmortizationBackToolbar from '@old/components/amortization/AmortizationBackToolbar.vue'
import { mapActions, mapState } from 'vuex'
import { locales_mixin } from '@old/mixins/locales_mixin'
import { api_mixin } from '@old/mixins/api_mixin'

export default {
    name: 'AmortizationSelect',
    props: {},
    mixins: [api_mixin, locales_mixin],
    components: { AmortizationBackToolbar },
    emits: ['next'],
    data() {
        return {
            selected_creditor: null,
            selected_debts: [],
            loading: false,
        }
    },
    computed: {
        creditors() {
            const creditor_ids = [...new Set(this.amortization.multiple.documents.map((v) => v['creditor']))]
            const result = []
            for (const id of creditor_ids) {
                const debts = this.amortization.multiple.documents.filter((v) => v['creditor'] === id)
                const name = `${debts[0]['creditor_name']} (${debts.length})`
                result.push({
                    id,
                    name,
                })
            }
            return result
        },
        debts() {
            if (!this.selected_creditor) return []
            return this.amortization.multiple.documents.filter((v) => v['creditor'] === this.selected_creditor)
        },
        ...mapState(['amortization']),
    },
    watch: {
        selected_creditor() {
            this.selected_debts = []
        },
    },
    methods: {
        label(debt) {
            const amount = this.format_as_currency(debt['total_remaining_transaction_amount'], debt['currency'])
            return `${amount} - ${debt['reference_number']}`
        },
        async next() {
            this.loading = true
            const documents = this.amortization.multiple.documents.filter((v) => this.selected_debts.includes(v['_id']))

            const [document] = documents
            const id = document['cases'] ? document['cases'][0]['case'] : document['_id']
            const response = await this.api_get({
                url: `/domain-actions/cases/new_amortization/${id}`,
            })
            const data = {
                ...this.amortization,
                params: {
                    ...response.data,
                    id: id,
                },
            }
            data['multiple']['selected'] = this.selected_debts
            this.set_state_property({
                property: 'amortization',
                data: data,
            })
            this.loading = false
            this.$emit('next')
        },
        ...mapActions(['update_key_in_state_property', 'set_state_property']),
    },
    beforeCreate() {},
    created() {},
    beforeMount() {},
    mounted() {
        if (this.creditors.length === 1) {
            this.selected_creditor = this.creditors[0]['id']
        }
    },
    beforeUpdate() {},
    updated() {},
    beforeUnmount() {},
}
</script>

<style scoped lang="sass"></style>
